<script setup lang="ts">
defineProps<{
  percentageWidth: string | number
  starCount: string
  reviewCount: number
}>()
</script>

<template>
  <div class="mb-1 flex items-center">
    <span class="mr-2 w-4">{{ starCount }}</span>
    <Icon name="i-heroicons:star-16-solid" class="mr-2 text-yellow-400" />
    <div class="h-4 flex-grow rounded-full bg-gray-200">
      <div class="h-4 rounded-full bg-yellow-400" :style="{ width: `${percentageWidth}%` }" />
    </div>
    <span class="ml-2 text-sm">{{ reviewCount }} x</span>
  </div>
</template>
